module.exports = __webpack_public_path__ + "img/mstile-150x150.fc52b2c7.png";